/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VerticalType = {
    Regular: 'REGULAR',
    Strategy: 'STRATEGY',
    CallForTender: 'CALL_FOR_TENDER'
} as const;
export type VerticalType = typeof VerticalType[keyof typeof VerticalType];


export function instanceOfVerticalType(value: any): boolean {
    for (const key in VerticalType) {
        if (Object.prototype.hasOwnProperty.call(VerticalType, key)) {
            // @ts-ignore
            if (VerticalType[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VerticalTypeFromJSON(json: any): VerticalType {
    return VerticalTypeFromJSONTyped(json, false);
}

export function VerticalTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerticalType {
    return json as VerticalType;
}

export function VerticalTypeToJSON(value?: VerticalType | null): any {
    return value as any;
}

